import { Source, useCreateEventMutation, useGetMeQuery } from '@pm/graphql';
import { useCallback } from 'react';
import { BackendEventMap } from './backend-event-types';

const mapBrandToSource = (brandName?: string): Source => {
  if (!brandName) return Source.Freddie;

  const lowerBrandName = brandName.toLowerCase();

  if (lowerBrandName.includes('freddie')) return Source.Freddie;
  if (lowerBrandName.includes('frida')) return Source.Frida;
  if (lowerBrandName.includes('purpose')) return Source.Purposemed;

  return Source.Freddie;
};

type UseTrackBackendEventParams = {
  userId?: string;
  source?: Source;
  brandName?: string;
};

export const useTrackBackendEvent = ({
  userId,
  source,
  brandName,
}: UseTrackBackendEventParams) => {
  const [createEvent] = useCreateEventMutation();
  const { data: meData, loading: userLoading } = useGetMeQuery();
  const currentUserId = userId || meData?.me?.id || '';

  const eventSource = source || mapBrandToSource(brandName);

  const trackBackendEvent = useCallback(
    <K extends keyof BackendEventMap>(
      eventName: K,
      properties?: BackendEventMap[K],
      options?: { braze?: boolean },
    ) => {
      if (userLoading) return;

      return createEvent({
        variables: {
          input: {
            userId: currentUserId,
            name: eventName,
            source: eventSource,
            properties: properties ?? {},
            braze: options?.braze,
          },
        },
      });
    },
    [createEvent, currentUserId, eventSource, userLoading],
  );

  return { trackBackendEvent };
};
